var _path;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgMoreOutlined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 14,
    viewBox: "0 0 3 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.015625 1.16667C0.015625 1.47609 0.138541 1.77283 0.357333 1.99162C0.576126 2.21042 0.872872 2.33333 1.18229 2.33333C1.49171 2.33333 1.78846 2.21042 2.00725 1.99162C2.22604 1.77283 2.34896 1.47609 2.34896 1.16667C2.34896 0.857247 2.22604 0.560501 2.00725 0.341709C1.78846 0.122916 1.49171 0 1.18229 0C0.872872 0 0.576126 0.122916 0.357333 0.341709C0.138541 0.560501 0.015625 0.857247 0.015625 1.16667ZM0.015625 7C0.015625 7.30942 0.138541 7.60617 0.357333 7.82496C0.576126 8.04375 0.872872 8.16667 1.18229 8.16667C1.49171 8.16667 1.78846 8.04375 2.00725 7.82496C2.22604 7.60617 2.34896 7.30942 2.34896 7C2.34896 6.69058 2.22604 6.39383 2.00725 6.17504C1.78846 5.95625 1.49171 5.83333 1.18229 5.83333C0.872872 5.83333 0.576126 5.95625 0.357333 6.17504C0.138541 6.39383 0.015625 6.69058 0.015625 7ZM0.015625 12.8333C0.015625 13.1428 0.138541 13.4395 0.357333 13.6583C0.576126 13.8771 0.872872 14 1.18229 14C1.49171 14 1.78846 13.8771 2.00725 13.6583C2.22604 13.4395 2.34896 13.1428 2.34896 12.8333C2.34896 12.5239 2.22604 12.2272 2.00725 12.0084C1.78846 11.7896 1.49171 11.6667 1.18229 11.6667C0.872872 11.6667 0.576126 11.7896 0.357333 12.0084C0.138541 12.2272 0.015625 12.5239 0.015625 12.8333Z",
    fill: "var(--secondary-7)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreOutlined);
export default __webpack_public_path__ + "static/media/moreOutlined.8a1c58e119c87f000a2f0f823bd058da.svg";
export { ForwardRef as ReactComponent };